import React from 'react';
import { SxProps } from '@mui/material';

import { OfferFilter } from '@occc/graphql';
import { useGetOfferSelectListLazy } from '@occc-app/dataAccessLayer/offer/queries';
import { FormInputProps, LazyAutocompleteFieldNotMultiple } from '@occc-app/design-system';

import { OfferItem } from './types';
import {
  mapOfferQueryResponseToRawArray,
  mapRawOffersResponseItemToAutocompleteOption,
} from './utils';

const inputProps: FormInputProps = { margin: 'none' };
const FIRST = 100;

export interface OfferSelectProps {
  makeOffersFilter: (search: string) => OfferFilter;
  label: string;
  name: string;
  sx?: SxProps;
  className?: string;
}

export const OfferSelect: React.FC<OfferSelectProps> = ({
  makeOffersFilter,
  label,
  name,
  sx,
  className,
}) => {
  return (
    <LazyAutocompleteFieldNotMultiple<
      OfferItem,
      ReturnType<typeof useGetOfferSelectListLazy>['response']
    >
      name={name}
      label={label}
      useLazyQuery={useGetOfferSelectListLazy}
      makeQueryFilter={makeOffersFilter}
      mapQueryResponseToRawArray={mapOfferQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawOffersResponseItemToAutocompleteOption}
      inputProps={inputProps}
      first={FIRST}
      sx={sx}
      className={className}
    />
  );
};
